import { useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actionTypes from '../../../actions/actionTypes';
import importOneLayerTags from '../../../actions/api/tag/importOneLayerTags';
import getTagsForLevel from '../functions/getTagsForLevel';

/**
 * 1階層のタグインポートダイアログのロジックを管理するカスタムフック
 *
 * @returns {object} カスタムフックから返されるオブジェクト。
 * @returns {React.MutableRefObject} importInputRef - ファイルインプット要素への参照
 * @returns {Function} handleCloseDialog - ダイアログを閉じるための関数
 * @returns {Function} handleImportButtonClick - インポートボタンをクリックするための関数
 * @returns {Function} handleFileChange - ファイル選択時のコールバック関数
 * @returns {object} selectedTag - 選択されたタグの情報。
 */
const useOneLayerMasterImport = () => {
  const dispatch = useDispatch();
  const { apiToken, selectedTag } = useSelector(state => ({
    apiToken: state.main.apiToken,
    selectedTag: state.master.selectedTag,
  }));
  const importInputRef = useRef(null);

  const handleCloseDialog = useCallback(() => {
    dispatch({ type: actionTypes.CLOSE_ONE_LAYER_MASTER_IMPORT_DIALOG });
  }, [dispatch]);

  const handleImportButtonClick = useCallback(() => {
    importInputRef.current.click();
  }, [importInputRef]);

  const handleFileChange = useCallback(
    async file => {
      await dispatch(
        importOneLayerTags(apiToken, file, {
          depth: selectedTag.depth,
          parentId: selectedTag.parentId && selectedTag.parentId,
        }),
      );

      dispatch(
        getTagsForLevel(apiToken, selectedTag.parentId, selectedTag.depth),
      );
    },
    [dispatch, apiToken, selectedTag],
  );

  return {
    importInputRef,
    handleCloseDialog,
    handleImportButtonClick,
    handleFileChange,
    selectedTag,
  };
};

export default useOneLayerMasterImport;
